import { useState } from 'react';
import { createContainer } from 'unstated-next';

export interface Payload {
  message: string;
  duration?: number | null;
  priority?: 'low' | 'high';
  // severity: 'success' | 'warning' | 'error';
}

interface Snackbar {
  payload: Payload[];
  queue: (payload: Payload) => void;
  pop: () => Payload | undefined;
  clear: () => void;
}

function useSnackbarInternal(): Snackbar {
  const [payload, setPayload] = useState<Payload[]>([]);

  return {
    payload,
    queue: data => {
      setPayload(cur => cur.concat(data));
    },
    pop: () => {
      const res = payload[0] ? { ...payload[0] } : undefined;
      setPayload(payload.slice(0, -1));
      return res;
    },
    clear: () => setPayload([]),
  };
}

const container = createContainer<Snackbar, Payload>(useSnackbarInternal);
const useSnackbar = container.useContainer;

export const SnackbarProvider = container.Provider;
export default useSnackbar;
